import React from 'react'
import './Overview.css'
import PropTypes from 'prop-types'
//MUI
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
//Redux
import { useSelector } from 'react-redux'

function OverviewInfo(props) {
  const { status, role, numDocFromYou, numDocToYou } = props
  const overview = useSelector((state) => state.overview)
  var title = ''
  switch (status) {
    case 'Completed':
    case 'Pending':
    case 'Rejected':
    case 'Expired':
      title = `${status}`
      break
    default:
      title = 'Document Due in 7 days'
  }

  let overviewMarkup =
    role === 'Requester' ? (
      <>
        <p className='overview-number'>{numDocFromYou}</p>
        <ArrowDropUpIcon fontSize='large' />
      </>
    ) : (
      <>
        {(overview.dropdownOption === 1 || overview.dropdownOption === 2) && <ArrowDropDownIcon fontSize='large' />}

        {(overview.dropdownOption === 1 || overview.dropdownOption === 2) && <p className='overview-number'>{numDocToYou}</p>}

        {overview.dropdownOption === 1 && <p style={{ fontSize: '60px', whiteSpace: 'pre' }}> / </p>}

        {(overview.dropdownOption === 1 || overview.dropdownOption === 3) && <p className='overview-number'>{numDocFromYou}</p>}

        {(overview.dropdownOption === 1 || overview.dropdownOption === 3) && <ArrowDropUpIcon fontSize='large' />}
      </>
    )

  return (
    <div className='overview-style no-select'>
      <p className='overview-title'>{title}</p>
      <div className='overview-content'>{overviewMarkup}</div>
    </div>
  )
}

OverviewInfo.propTypes = {
  status: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  numDocFromYou: PropTypes.number.isRequired,
  numDocToYou: PropTypes.number.isRequired,
}

export default OverviewInfo
